import React from "react";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import breathImage from "../Images/Home_Pg_Img_1.jpg";
import yogaImage from "../Images/ProfilePic.jpg";
import communityImage from "../Images/calm.jpg";
import groupImage from "../Images/GroupPic.jpeg";

const sessions = [
  {
    image: breathImage,
    imageAlt: "Calm sunrise over water",
    eyebrow: "ONLINE · FREE",
    title: "Breathe Better. Live Better.",
    subtitle: "Intro to breathwork and meditation",
    location: "Join online from anywhere",
    description:
      "Explore the connection between breath and mind, and try practical tools for everyday calm.",
    href: "https://www.eventbrite.com/e/beyond-breath-introduction-to-sky-breath-meditation-program-online-tickets-144276124773",
    action: "See session dates",
  },
  {
    image: yogaImage,
    imageAlt: "Sowmya leading a yoga practice with a community group",
    eyebrow: "IN PERSON · FREE",
    title: "Free Yoga & Meditation",
    subtitle: "A welcoming introduction for all levels",
    location: "1045 Hanson Crescent, London",
    description:
      "Try gentle yoga and meditation in a friendly setting. No previous experience is needed.",
    href: "https://www.eventbrite.ca/e/free-yoga-and-meditation-for-a-calm-mind-intro-to-the-art-of-living-tickets-840295605777",
    action: "Reserve your spot",
  },
  {
    image: communityImage,
    imageAlt: "Sunset over a peaceful lake",
    eyebrow: "COMMUNITY · SEE DATES",
    title: "Mantra, Music & Meditation",
    subtitle: "Gather, listen, and recharge together",
    location: "See event details for location",
    description:
      "Join a relaxed community gathering with music, meditation, and time to connect.",
    href: "https://linktr.ee/aolspecialevents",
    action: "See upcoming gatherings",
  },
];

function WeeklySessions({ id = "Workshops-section" }) {
  return (
    <section className="weekly-sessions" id={id}>
      <div className="weekly-sessions__inner">
        <header className="weekly-sessions__header">
          <p className="home-eyebrow">COME AS YOU ARE</p>
          <h2>Free Weekly Sessions</h2>
          <p>
            Find a little more calm, energy, and connection in a welcoming
            community. Everyone is welcome.
          </p>
        </header>

        <div className="weekly-sessions__cards">
          {sessions.map((session) => (
            <article className="weekly-session-card" key={session.title}>
              <img
                className="weekly-session-card__image"
                src={session.image}
                alt={session.imageAlt}
              />
              <div className="weekly-session-card__content">
                <p className="weekly-session-card__eyebrow">
                  {session.eyebrow}
                </p>
                <h3>{session.title}</h3>
                <p className="weekly-session-card__subtitle">
                  {session.subtitle}
                </p>
                <ul className="weekly-session-card__details">
                  <li>
                    <CalendarMonthIcon aria-hidden="true" />
                    <span>Check the link for upcoming dates</span>
                  </li>
                  <li>
                    <LocationOnIcon aria-hidden="true" />
                    <span>{session.location}</span>
                  </li>
                </ul>
                <p className="weekly-session-card__description">
                  {session.description}
                </p>
                <a
                  className="weekly-session-card__action"
                  href={session.href}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {session.action}
                  <ArrowForwardIcon aria-hidden="true" />
                </a>
              </div>
            </article>
          ))}
        </div>

        <aside className="group-wellness">
          <img
            className="group-wellness__image"
            src={groupImage}
            alt="A large local community gathered for a yoga event"
          />
          <div className="group-wellness__content">
            <p className="home-eyebrow">SCHOOLS · WORKPLACES · COMMUNITY GROUPS</p>
            <h2>Bring yoga and meditation to your group</h2>
            <p>
              Sowmya has extensive experience leading group sessions. Get in
              touch to plan a welcoming experience shaped around your group,
              setting, and goals.
            </p>
            <div className="group-wellness__actions">
              <a className="group-wellness__contact" href="#contact-section">
                Contact to schedule
                <ArrowForwardIcon aria-hidden="true" />
              </a>
              <a className="group-wellness__phone" href="tel:+12265826067">
                226-582-6067
              </a>
            </div>
          </div>
        </aside>
      </div>
    </section>
  );
}

export default WeeklySessions;
